import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux';
import { HashRouter, Route, Switch } from "react-router-dom";

import indexRoutes from "./routes/index.jsx";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/light-bootstrap-dashboard.css?v=1.1.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

import configureStore from './store/configureStore';

import auth from './lib/auth'

auth.config({
  redirectLogin: "/#/admin",
  redirectNotLogin: "/",
  redirectNotAuthorization: "/#/notRole"
})

ReactDOM.render(
  <Provider store={configureStore()}>
    <HashRouter>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return (
            <Route path={prop.path} component={prop.component} key={key} />
          );
        })}
      </Switch>
    </HashRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js